import React, { Component, Fragment } from 'react'
import { isEmpty } from 'lodash'
import { Helmet } from 'react-helmet'
import { translate } from 'react-i18next'
import { Link } from 'react-router-dom'
import pathToRegexp from 'path-to-regexp' // we have this lib becasue of installed react-router-dom
import Cat from '../entities/Cat'
import Error from './Error'
import Layout from './Layout'
import PostThumb from '../containers/PostThumb'
import RecursiveElement from './RecursiveElement'
import Spinner from './Spinner'

/*
 * TODO:
 * - nested categories
 * - read more?
 */

class Posts extends Component {
  constructor(props) {
    super(props)
    this.state = {
      posts: null,
      title: null,
      error: null,
      limit: 5, // FIXME: from props?
      nextPage: null,
      isFetching: null
    }

    if (isEmpty(props.cats.items) || (props.cats.code !== null && props.cats.code !== 200)) {
      props.findAllCats() // required
      // findPost will be dispatched on componentDidUpdate
    } else {
      const {cat, target, page} = this.findPostsParams()
      if (cat !== undefined && (props.pagination[target] === undefined || props.pagination[target].pageCount > 1)) {
        props.findPosts({ target, reset: true, cats: [cat.getTarget()], page, limit: this.state.limit, pageView: true })
      }
    }
  }

  findPostsParams = () => {
    const cat = this.props.match.params.cat !== undefined ? this.props.cats.items[this.props.match.params.cat] : new Cat({ title: "All posts" })
    const target = 'category-' + cat.getTarget()
    const page = parseInt(this.props.match.params.page || '1', 10)
    return { cat, target, page }
  }

  toPath = (params) => (pathToRegexp.compile(this.props.match.path))(params)

  static getDerivedStateFromProps(props, state) {
    if (props.cats.code !== null && props.cats.code !== 200)
      return { error: 'err.oops' }

    // FIXME: if is fetching?
    if (isEmpty(props.cats.items))
      return null

    const cat = props.match.params.cat !== undefined ? props.cats.items[props.match.params.cat] : new Cat({ title: "All posts" })
    if (cat === undefined)
      return { error: 'err.catNotExist' }

    const target = 'category-' + cat.getTarget()
    const title = cat.getTitle()

    // FIXME: if is fetching?
    const pagination = props.pagination[target]
    if (pagination === undefined) return null

    if (pagination.code !== null && pagination.code !== 200)
      return { error: {keys: 'err.loadingPost', options: { count: 100 }} }

    return {
      posts: pagination.ids.map(id => props.posts[id]),
      title,
      error: null,
      nextPage: pagination.nextPage,
      isFetching: pagination.isFetching
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // FIXME: those ifs are separated only for easy debbugind. join before deploy.

    // new cats received (async api request initiated in constructor has finished)
    if (!isEmpty(this.props.cats.items) && isEmpty(prevProps.cats.items)) {
      const {cat, target, page} = this.findPostsParams()
      if (cat !== undefined && this.props.pagination[target] === undefined) {
        this.props.findPosts({ target, reset: true, cats: [cat.getTarget()], page, limit: this.state.limit, pageView: true })
      }
    }

    // new page viewed (page or category has changed)
    if (parseInt(this.props.match.params.page || '1', 10) > parseInt(prevProps.match.params.page || '1', 10)) {
      const {cat, target, page} = this.findPostsParams()
      this.props.findPosts({ target, cats: [cat.getTarget()], page, limit: this.state.limit, pageView: true })
    } else if (parseInt(this.props.match.params.page || '1', 10) < parseInt(prevProps.match.params.page || '1', 10)) {
      const {cat, target, page} = this.findPostsParams()
      this.props.findPosts({ target, reset: true, cats: [cat.getTarget()], page, limit: this.state.limit, pageView: true })
    } else if (this.props.match.params.cat !== prevProps.match.params.cat) {
      const {cat, target, page} = this.findPostsParams()
      this.props.findPosts({ target, reset: true, cats: [cat.getTarget()], page, limit: this.state.limit, pageView: true })
    }

    // FIXME if cats.code === error || pagination.code === error then refresh?
  }

  render() {
    if (this.state.error)
      return <Layout><Error>{this.props.t(this.state.error.keys || this.state.error, this.state.error.options)}</Error></Layout>

    return (
      <Layout title={this.state.title}>
        {this.state.posts !== null ?
          <Fragment>
            <Helmet>
              <title>{this.state.title}</title>
            </Helmet>
            {this.state.posts.map((post, key) => (
              <div key={key}>
                {post.getMedia() ?
                  <PostThumb mediaId={post.getMedia()} />
                :
                  null
                }
                <h2>{post.getTitle()}</h2>
                <RecursiveElement element={post.getDom()} />
              </div>
            ))}
            {this.state.nextPage ?
              <Link to={this.toPath({ lng: this.props.i18n.language, page: this.state.nextPage, cat: this.props.match.params.cat })}>{this.props.t('lbl.more')}</Link>
            :
              null
            }
          </Fragment>
        :
          <Spinner>{this.props.t('msg.loadingPost', { count: 100 })}</Spinner>
        }
      </Layout>
    )
  }
}

export default translate()(Posts)



// WEBPACK FOOTER //
// ./src/components/Posts.js